import type {
  Envelope,
  SimulationRoomEvent,
} from "../routes/simulationRoomTypes"

/**
 * Folds one transcript.event envelope into the event map.
 *
 * Events are never revised, but a replay re-delivers them after live messages
 * with higher sequence numbers — so dedupe per event id, and keep the lowest
 * sequence number seen as the ordering position, same as segments.
 */
export function mergeTranscriptEvent(
  current: Map<string, SimulationRoomEvent>,
  envelope: Envelope,
): Map<string, SimulationRoomEvent> {
  const payload = envelope.payload as {
    event_id: string
    role: string
    content: string
    name: string
    tool_call_owner?: string
    start_offset_seconds?: number
    end_offset_seconds?: number
  }
  const existing = current.get(payload.event_id)
  if (existing && envelope.seq >= existing.orderSeq) {
    return current
  }
  const next = new Map(current)
  next.set(payload.event_id, {
    eventId: payload.event_id,
    seq: envelope.seq,
    orderSeq: Math.min(existing?.orderSeq ?? envelope.seq, envelope.seq),
    role: payload.role,
    content: payload.content,
    name: payload.name,
    toolCallOwner: payload.tool_call_owner,
    startOffsetSeconds: payload.start_offset_seconds,
    endOffsetSeconds: payload.end_offset_seconds,
  })
  return next
}
